import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reg-pmsdemo',
  templateUrl: './reg-pmsdemo.component.html',
  styleUrls: ['./reg-pmsdemo.component.scss']
})
export class RegPMSdemoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
